// STAFF-HOME — صفحه خانه پوسته (AP-008) با کارت «ادامه راه‌اندازی» (AP-PLT-04). صفحه خانه نقش‌محور (IA §2.2) هنوز جایگزین نشده
// (C-AGENT-345، C-AGENT-372).
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { unwrap } from '@phoenix/api-client';
import { useAuth, useTenantName, useTenantSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { faDigits, PageHeader, QueryState } from '@phoenix/ui';
import { useQuery } from '@tanstack/react-query';
import { SetupContinueCard } from './setup/SetupContinueCard';

export const STAFF_HOME = 'STAFF-HOME';

export function HomePage() {
  const { t } = useTranslation('shell');
  const auth = useAuth();
  const { tenantApi, activeTenant, session } = useTenantSession();
  const tenantName = useTenantName();

  // بافت نشست از توکن مستأجر (GET identity/sessions/current) — شاهد پاک شدن Cache هنگام جابه‌جایی مستأجر.
  const current = useQuery({
    queryKey: ['identity', 'sessions', 'current'],
    queryFn: () => unwrap(tenantApi.GET('/api/v1/identity/sessions/current')),
  });

  const branchName =
    activeTenant?.branches.find((branch) => branch.branchId === session?.activeBranchId)?.name ??
    t('shell:home.no_active_branch');

  return (
    <Stack data-screen-id={STAFF_HOME} spacing={2}>
      <PageHeader
        titleKey="shell:home.title"
        titleValues={{ name: auth.user?.name ?? auth.user?.username ?? '' }}
        subtitleKey="shell:home.description"
      />
      {/* AP-PLT-04: تا کامل شدن مراحل الزامی راه‌اندازی (و هدایت ورود نخست به Wizard). */}
      <SetupContinueCard />
      <Card variant="outlined">
        <CardContent>
          <QueryState
            isPending={current.isPending}
            error={current.error}
            data={current.data}
            onRetry={() => void current.refetch()}
          >
            {(data) => (
              <Stack spacing={0.5} data-testid="session-summary" data-tenant-id={data.tenantId}>
                <Typography>
                  {t('shell:home.tenant')}: <strong>{tenantName(activeTenant)}</strong>
                </Typography>
                <Typography>
                  {t('shell:home.branch')}: <strong>{branchName}</strong>
                </Typography>
                <Typography color="text.secondary">
                  {t('shell:home.branch_count', { value: faDigits(data.branchIds.length) })}
                </Typography>
              </Stack>
            )}
          </QueryState>
        </CardContent>
      </Card>
    </Stack>
  );
}
